import { Card } from '@costar-ui/components';
import React from 'react';
import { ArticleCard } from './components/article-card.esm.js';

var NewsIcGrid = function NewsIcGrid(_ref) {
  var articles = _ref.articles;
  return /*#__PURE__*/React.createElement(Card, {
    bordered: false,
    padding: "none"
  }, /*#__PURE__*/React.createElement(Card.Body, {
    direction: "horizontal"
  }, articles.map(function (article) {
    return /*#__PURE__*/React.createElement(ArticleCard, {
      article: article,
      key: article.id
    });
  })));
};

export { NewsIcGrid };
//# sourceMappingURL=news-ic-grid.esm.js.map
